module.exports = __webpack_public_path__ + "static/media/useradd.a344da05.svg";